import { LearningPortfolioCategory } from './learning-portfolio-category';
import { LearningPortfolioContext } from './learning-portfolio-context';
import { LearningPortfolioAttachment } from './learning-portfolio-attachment';
import { LearningPortfolioPayload, LearningPortfolioTextPayload } from './learning-portfolio-payload';
import { LearningPortfolioNoteDto, LearningPortfolioNoteType, READONLY_NOTE_TYPES, UNDELETABLE_NOTE_TYPES } from './learning-portfolio.dto';

export class LearningPortfolioNote {
    readonly id: string;
    readonly type: LearningPortfolioNoteType;
    readonly payload: LearningPortfolioPayload;
    readonly categories: LearningPortfolioCategory[];
    readonly context: LearningPortfolioContext | null;
    readonly attachments: LearningPortfolioAttachment[];
    readonly createdAt: Date;
    readonly updatedAt: Date;
    readonly editable: boolean;
    readonly deletable: boolean;

    constructor(dto: LearningPortfolioNoteDto) {
        this.id = dto.id;
        this.type = dto.type;
        this.payload = new LearningPortfolioTextPayload(dto.payload);
        this.categories = dto.categories.map((category) => new LearningPortfolioCategory(category));
        this.context = dto.context ? new LearningPortfolioContext(dto.context) : null;
        this.attachments = dto.attachments.map((attachment) => new LearningPortfolioAttachment(attachment));
        this.createdAt = new Date(dto.createdAt * 1000);
        this.updatedAt = new Date(dto.updatedAt * 1000);
        this.editable = !READONLY_NOTE_TYPES.includes(dto.type);
        this.deletable = !UNDELETABLE_NOTE_TYPES.includes(dto.type);
    }
}
